(() => {
  if (location.hash !== '#film-check') return;
  const panel = document.createElement('aside');
  panel.style.cssText = 'position:fixed;z-index:2147483647;left:8px;right:8px;bottom:56px;padding:10px;background:#fff;color:#111;border:2px solid #735d3b;font:12px/1.3 monospace;max-height:58svh;overflow:auto';
  const title = document.createElement('strong'); title.textContent = 'Fu.Topia 手机检测 0929-R5';
  const output = document.createElement('pre'); output.style.cssText = 'white-space:pre-wrap;user-select:text;margin:8px 0';
  const close = document.createElement('button'); close.textContent = '关闭检测'; close.style.cssText='min-height:44px;padding:8px';
  panel.append(title, output, close); document.body.append(panel);
  const tick = () => {
    const f = document.querySelector('futopia-mobile-film,futopia-welcome-film');
    const v = f?.querySelector('video');
    const result = {
      check: '0929-R5',
      theme: window.Shopify?.theme?.id,
      build: f?.dataset.filmBuild || 'not-entered',
      routed: f?.dataset.filmRouted || 'none',
      upgraded: !!(f && customElements.get(f.localName) && f instanceof customElements.get(f.localName)),
      step: f?.dataset.filmStep || 'not-entered',
      initError: f?.dataset.filmInitError || null,
      elements: f ? ['video','.ft-film__stage','[data-play]','[data-cue]'].map(s => !!f.querySelector(s)).join(',') : 'none',
      width: innerWidth, scroll: Math.round(scrollY),
      state: f?.dataset.filmState || 'not-set',
      ready: v?.readyState, network: v?.networkState,
      time: v?.currentTime?.toFixed(2), target: f?.targetTime?.toFixed(2),
      duration: Number.isFinite(v?.duration) ? v.duration.toFixed(2) : 'unknown',
      error: v?.error ? v.error.code + ': ' + v.error.message : null,
      playError: f?.lastPlayError || null,
      sourceSet: !!v?.getAttribute('src'),
      transport: f?.dataset.filmTransport || 'native',
      seeking: v?.seeking, seekMs: Math.round(f?.seekMs || 0),
      recoveries: f?.seekRecoveries || 0, resumes: f?.resumeCount || 0, needsWake: !!f?.needsWake, priming: !!f?.priming,
      mp4: (f?.sourceURL || v?.currentSrc)?.split('/').pop()?.split('?')[0] || 'none'
    };
    output.textContent = JSON.stringify(result, null, 1);
  };
  tick(); const timer = setInterval(tick, 500);
  close.addEventListener('click', () => { clearInterval(timer); panel.remove(); });
})();
